
import {
    defineComponent,
    ref,
    reactive,
    getCurrentInstance,
    onMounted,
} from 'vue'
import { useTableScroll } from '@/common/mixins/useTableScroll'
import { modeOptions, appColumns } from './config'
import { appList, releaseApp } from './request'
import { message } from 'ant-design-vue'
import Add from './components/Add.vue'
export default defineComponent({
    components: {
        Add,
    },
    setup() {
        const loading = ref(false)
        const data = ref<any>([])
        const filter = reactive({
            name: '',
        })
        const instance = getCurrentInstance()
        const { scroll } = useTableScroll(instance)
        const columns = appColumns
        const fetchList = async () => {
            try {
                const params = {
                    ...filter,
                }
                loading.value = true
                const res = await appList(params)
                loading.value = false
                data.value = res.data
                if (data.value?.length) {
                    data.value = data.value.map((item: any) => {
                        return {
                            ...item,
                            enable: item.isRelease === 1,
                        }
                    })
                }
            } catch (error) {
                loading.value = false
                console.log(error)
            }
        }
        // 下架or上架
        const handleEnable = async (record: any) => {
            try {
                const params = {
                    id: record.id,
                    release: record.enable ? 1 : 0,
                }
                loading.value = true
                await releaseApp(params)
                loading.value = false
                let text = record.enable ? '应用已上架' : '应用已下架'
                message.success(text)
            } catch (error) {
                loading.value = false
                console.log(error)
            }
        }
        const addState = reactive({
            visible: false,
            detail: null,
        })
        const type = ref('add')
        // 新增应用
        const add = () => {
            addState.visible = true
            addState.detail = null
            type.value = 'add'
        }
        // 编辑应用
        const mod = (record: any) => {
            addState.visible = true
            addState.detail = record
            type.value = 'mod'
        }
        // 关闭弹框
        const closeAddModal = () => {
            addState.visible = false
            addState.detail = null
        }

        onMounted(() => {
            fetchList()
        })
        return {
            loading,
            data,
            filter,
            modeOptions,
            scroll,
            columns,
            fetchList,
            handleEnable,
            addState,
            type,
            add,
            mod,
            closeAddModal,
        }
    },
})
